export default () => typeof document !== 'undefined' && 'classList' in document.createElement('a');
